// extracted by mini-css-extract-plugin
module.exports = {"meals":"MealsList_meals__3g62A","meals-appear":"MealsList_meals-appear__2XbyM","error":"MealsList_error__1JjBI"};